/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// DATE PICKER FILTER
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme =>({
    daypickerdropdown:{
        height: pxToEm(56),
        minWidth: pxToEm(305),
        maxWidth: pxToEm(305), //pxToEm(255),
        position: 'relative',
        '& .placeholder': {
            width:'100%',
            height:'100%',
            fontSize: pxToEm(15),
            padding: pxToEm(18),
            color: theme.color.primary.medium.swatch,
            background: theme.color.light.light.swatch,
            borderRadius: pxToEm(4),
            display: 'flex',
            justifyContent: 'space-between',
            alignItems:'center',
            boxShadow: theme.boxShadow.small,
            cursor: 'pointer',
            border: `${pxToEm(2)} solid transparent`,
            transition: 'border .2s linear 0s',
            '& .icon':{
                color: theme.color.primary.dark.swatch
            },
            '&:hover':{
                borderColor: theme.color.secondary.light.swatch
            },
            '&.active-true': {
                borderColor: theme.color.primary.medium.swatch
            }
        },
        '& .name-dropdown': {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            background: theme.color.light.light.swatch,
            // maxHeight: pxToEm(385),
            width: pxToEm(325),
            height: pxToEm(325),
            padding: pxToEm(25),
            transition: 'all .15s',
            position: 'absolute',
            zIndex: 1,
            right: 0,
            boxShadow: theme.boxShadow.small,
            '&.active-false': {
                height: '0px',
                overflow: 'hidden',
                transition: 'all .15s',
                padding: 0
            },
            '& .datepicker': {
                marginTop: pxToEm(5)
            }
        }
    }
})